'use client';

import * as DS from '@aurorasolar/ds';
import { ReactNode, useId } from 'react';

type Props = {
  blurb: string;
  children?: ReactNode;
  detail?: string;
  disabled?: boolean;
  label: string;
  onToggle: (toggled: boolean) => void;
  toggled: boolean;
};

export const SolutionToggleRow = ({ blurb, children, detail, disabled, label, onToggle, toggled }: Props) => {
  const labelId = useId();

  return (
    <DS.Flex bg="uiBgAlternate" borderRadius={8} gap={1} p={4} textAlign="left">
      <DS.Flex alignItems="center" flexDirection="row" gap={4} justifyContent="space-between">
        <DS.Text fontWeight="medium" id={labelId} text="body14">
          {label}
        </DS.Text>
        <DS.Toggle
          disabled={disabled}
          handleToggle={() => onToggle(!toggled)}
          toggleProps={{ 'aria-labelledby': labelId }}
          toggled={toggled}
        />
      </DS.Flex>
      <DS.Text color="uiHelperCopy" text="body12">
        {detail ? `${blurb} ${detail}` : blurb}
      </DS.Text>
      {children ? <DS.Flex pt={2}>{children}</DS.Flex> : null}
    </DS.Flex>
  );
};
